/**
 * This utility class helps to manage the live chat
 */
import Cookies from 'js-cookie';
import TrackingComponent from '../components/TrackingComponent';

class ChatUtils {
  constructor() {
    this.TrackingComponent = new TrackingComponent();
  }
  // common selectors, overridable
  get SELECTORS() {
    return {
      // configs
      liveChatLanguage: '#liveChatLanguage', // live chat language
      urlEnvironmentSF: '#urlEnvironmentSF', // main url
      urlEnvironmentSnapIn: '#urlEnvironmentSnapIn', // snap in url
      chatOrgId: '#chatOrgId', // salesforce id of MM
      buttonNameSnapIn: '#buttonNameSnapIn', // button name
      buttonIdSnapIn: '#buttonIdSnapIn', // button name
      baseLiveAgentContentURL: '#baseLiveAgentContentURL', // live agent url
      deploymentIdSnapIn: '#deploymentIdSnapIn', // deployment id
      baseLiveAgentURL: '#baseLiveAgentURL', // base live agent url
      eswLiveAgentDevName: '#eswLiveAgentDevName', // base live agent url
      chatBrand: '#chatBrand', // brand
      // labels
      chatLabelOnline: '#chatLabelOnline', // chat label when online
      chatLabelOffline: '#chatLabelOffline', // chat label when offline
      chatLabelStart: '#chatLabelStart', // chat label start
      chatLabelName: '#chatLabelName', // chat label name
      chatLabelLastname: '#chatLabelLastname', // chat label name
      chatLabelEmail: '#chatLabelEmail', // chat label name
      chatLabelSubject: '#chatLabelSubject', // chat label subject
      chatLabelPrivacy: '#chatLabelPrivacy', // chat label subject
      chatLabelSubjectOptionPS: '#chatLabelSubjectOptionPS', // chat label subject
      chatLabelSubjectOptionOD: '#chatLabelSubjectOptionOD', // chat label subject
      chatLabelSubjectOptionPay: '#chatLabelSubjectOptionPay', // chat label subject
      chatLabelSubjectOptionFi: '#chatLabelSubjectOptionFi', // chat label subject
      chatLabelSubjectOptionCS: '#chatLabelSubjectOptionCS', // chat label subject
      chatLabelSubjectOptionPAv: '#chatLabelSubjectOptionPAv', // chat label subject
      chatLabelSubjectOptionSt: '#chatLabelSubjectOptionSt', // chat label subject
      chatLabelSubjectOptionRR: '#chatLabelSubjectOptionRR', // chat label subject
      chatLabelSubjectOptionTA: '#chatLabelSubjectOptionTA', // chat label subject
      chatPreselectedSubject: '#chatPreselectedSubject', // chat preselected subject
      chatLabelCTA: '#chatLabelCTA', // chat label subject
      chatLabelLengthError: '#chatLabelLengthError', // chat label subject
      // elements
      chatDock: '.modalContainer.embeddedServiceSidebar.layout-docked.sidebarMaximized .dockableContainer',
      chatButton: '.livechat-button > .helpButton > .uiButton',
      endChatMessage: '.embeddedServiceLiveAgentStateChat .messageArea',
      endChatContainer: '.embeddedServiceLiveAgentStateChat .endChatContainer',
      endChatContent: '#thank-you-feedback',
      // PS ?
      personalStylistSnapConfig: '#buttonSnapConfig_personal_stylist',
      personalStylistPopUpTriggerTime: '#personalStylistPopUpTriggerTime',
      personalStylistBanner: '.live-chat-personal-stylist-cta',
      personalStylistStartChat: '.live-chat-personal-stylist-cta .start-chat',
      personalStylistStartWhatsApp: '.live-chat-personal-stylist-cta .start-whatsapp',
      personalStylistCloseBtn: '.live-chat-personal-stylist-cta .icon-close',
      customerLoggedIn: '#customerLoggedIn',
      customerFirstName: '#customerFirstName',
      customerLastName: '#customerLastName',
      customerEmail: '#customerEmail',
      // extra link chat
      startChatLink: '[data-name=live-chat] a',
    }
  }

  setEnvironment(options = false) {
    // all default selectors
    var defaultSelectors = this.SELECTORS;
    // merge def selectors with override
    if (typeof options.selectors !== 'undefined') {
      // var allSelectors = Object.assign(options.selectors,defaultSelectors);
      var allSelectors = Object.assign(defaultSelectors,options.selectors);
    } else {
      // or default assign
      var allSelectors = defaultSelectors;
    }
    // loop the selectors to make them available
    for (const key in allSelectors) {
      if (allSelectors.hasOwnProperty(key)) {
        // console.log(`${key}: ${allSelectors[key]}`);
        // set value
        this[key] = this.setValue(key,allSelectors);
      }
    }
    // set the options available
    if (typeof options !== 'undefined') {
      this.options = options;
    }
    // cookie key
    if (typeof options.cookieKey === 'undefined') {
      this.hideCookieKey = 'ps_button_hide';
      this.options.cookieKey = 'ps_button_hide';
    } else {
      this.hideCookieKey = this.options.cookieKey;
    }
  }

  /////////////////////////
  /*  GENERAL FUNCTIONS  */
  /////////////////////////

  // set value from selectors key
  setValue(labelName,allSelectors,noValue = null) {
    var selector = allSelectors[labelName];
    if (document.querySelector(selector) != null) {
      var toRet = document.querySelector(selector).value;
      // but if is not an input i want to return the selector
      if (typeof toRet == 'undefined' && document.querySelector(selector).tagName.toLowerCase() != 'input') {
        toRet = document.querySelector(selector);
      }
    } else {
      toRet = noValue;
    }
    //
    return toRet;
  }

  // return a value of selectors
  getValue(property) {
    return this.setValue(property,this.SELECTORS);
  }

  /////////////////////////
  /*       CHAT PART     */
  /////////////////////////

  // initiate the chat
  initializeChat(ps = false) {
    // this
    var ctx = this;
    // big config chunk for salesforce
    var initESW = function(gslbBaseURL) {
      // help btn
      embedded_svc.settings.displayHelpButton = true;
      // language conf fallback to en
      var language = (ctx.liveChatLanguage != '') ? ctx.liveChatLanguage : 'en';
      embedded_svc.settings.language = language;
      // directbutton routing on select subject
      embedded_svc.settings.directToButtonRouting = function(prechatFormData) {
        // subject is the fourth field on prechat list form
        if (prechatFormData[3].value == "Personal Stylist") {
          embedded_svc.settings.fallbackRouting = [ctx.personalStylistSnapConfig,ctx.buttonIdSnapIn];
          return ctx.personalStylistSnapConfig;
        } else {
          return ctx.buttonIdSnapIn;
        }
      }
      // country
      var country = document.querySelector('body').dataset.website != null ? document.querySelector('body').dataset.website.toUpperCase() : "";
      // prechat fields
      var prechatFields = {
        Primary_Language__c: language.toUpperCase(),
        website_iso_country_code__c: country,
        LiveChat_Brand__c: ctx.chatBrand,
        LiveChat_Path1__c: window.location.href.slice(0, -1)+ChatUtils.readCookie(ChatUtils.COOKIE_CONSTANTS.PATH_1),
        LiveChat_Path2__c: window.location.href.slice(0, -1)+ChatUtils.readCookie(ChatUtils.COOKIE_CONSTANTS.PATH_2),
        LiveChat_Path3__c: window.location.href.slice(0, -1)+ChatUtils.readCookie(ChatUtils.COOKIE_CONSTANTS.PATH_3),
        LiveChat_Path4__c: window.location.href.slice(0, -1)+ChatUtils.readCookie(ChatUtils.COOKIE_CONSTANTS.PATH_4),
        LiveChat_Path5__c: window.location.href.slice(0, -1)+ChatUtils.readCookie(ChatUtils.COOKIE_CONSTANTS.PATH_5),
      };
      //
      // if is personal stylist i should update the routing
      if(ps) {
        // this made the PS working
        embedded_svc.settings.fallbackRouting = [ctx.personalStylistSnapConfig,ctx.buttonIdSnapIn];
        // adding prechat fields
        prechatFields.FirstName = ctx.customerFirstName;
        prechatFields.LastName = ctx.customerLastName;
        prechatFields.Email = ctx.customerEmail;
        prechatFields.LiveChat_Subject__c = 'Personal Stylist';
      } else {
        // remove if there is
        delete embedded_svc.settings.fallbackRouting;
      }
      // fill prechat fields
      embedded_svc.settings.prepopulatedPrechatFields = prechatFields;
      // labels
      embedded_svc.settings.defaultAssistiveText = '';
      embedded_svc.settings.defaultMinimizedText = ctx.chatLabelOnline; // (Defaults to Chat with an Expert)
      embedded_svc.settings.disabledMinimizedText = ctx.chatLabelOffline; // (Defaults to Agent Offline)
      //
      embedded_svc.settings.enabledFeatures = ['LiveAgent'];
      embedded_svc.settings.entryFeature = 'LiveAgent';
      // on off button
      embedded_svc.addEventHandler('onAvailability', function (data) {
        var eventName = data.isAgentAvailable ? 'chatButtonEnabled' : 'chatButtonDisabled';
        var evt = document.createEvent("Events");
        evt.initEvent(eventName, true, true);
        document.dispatchEvent(evt);
      });
      embedded_svc.addEventHandler("onSettingsCallCompleted", function(data) {
        var eventName = data.isAgentAvailable ? 'chatButtonEnabled' : 'chatButtonDisabled';
        var evt = document.createEvent("Events");
        evt.initEvent(eventName, true, true);
        document.dispatchEvent(evt);
      });

      // after chat is closedddd
      embedded_svc.addEventHandler('afterDestroy', function() {
        // if i used the PS chat
        if (ctx.personalStylistBanner != null && ctx.personalStylistBanner.classList.contains('disappeared')) {
          // i reinit at the destroy
          ctx.initializeChat();
        }

        const eventName = 'closeChat';
        const evt = new Event(eventName, {
          bubbles: true,
          cancelable: true
        });
        document.dispatchEvent(evt);
      });
      // afterMinimize
      embedded_svc.addEventHandler('afterMinimize', function() {
        // afterMinimize
        const eventName = 'afterMinimize';
        const evt = new Event(eventName, {
          bubbles: true,
          cancelable: true
        });
        document.dispatchEvent(evt);
      });
      // on chat ended by user
      embedded_svc.addEventHandler("onChatEndedByChasitor", function() {
        ctx.TrackingComponent.actions.deleteChat();
      });

      //
      // console.log(embedded_svc.settings);
      //
      embedded_svc.init(
        ctx.urlEnvironmentSF,
        ctx.urlEnvironmentSnapIn,
        gslbBaseURL,
        ctx.chatOrgId,
        ctx.buttonNameSnapIn,
        {
          baseLiveAgentContentURL: ctx.baseLiveAgentContentURL,
          deploymentId: ctx.deploymentIdSnapIn,
          buttonId: ctx.buttonIdSnapIn,
          baseLiveAgentURL: ctx.baseLiveAgentURL,
          eswLiveAgentDevName: ctx.eswLiveAgentDevName,
          isOfflineSupportEnabled: false
        }
      );
    };
    // launch chat
    initESW('https://service.force.com');
  }

  /////////////////////////
  /*     COOKIES PART    */ /* legacy part */
  /////////////////////////
  // static
  static get COOKIE_CONSTANTS(){
    return {
      SIZE: 5,
      PATH: 'Path',
      PATH_1: 'Path1',
      PATH_2: 'Path2',
      PATH_3: 'Path3',
      PATH_4: 'Path4',
      PATH_5: 'Path5',
    }
  }
  static shiftPathCookies() {
    for(var i = 0; i < ChatUtils.COOKIE_CONSTANTS.SIZE - 1; i++) {
      ChatUtils.writeCookie(ChatUtils.COOKIE_CONSTANTS.PATH + (ChatUtils.COOKIE_CONSTANTS.SIZE - i), ChatUtils.readCookie(ChatUtils.COOKIE_CONSTANTS.PATH + (ChatUtils.COOKIE_CONSTANTS.SIZE - i - 1 )));
    }
  }
  static readCookie(cookieName) {
    if (document.cookie.length > 0) {
      var start = document.cookie.indexOf(cookieName + "=");
      if (start != -1) {
        start = start + cookieName.length + 1;
        var end = document.cookie.indexOf(";", start);
        if (end == -1) end = document.cookie.length;
        return unescape(document.cookie.substring(start, end));
      }
      else {
        return "";
      }
    }
    return "";
  }
  static writeCookie(cookieName, cookieValue) {
    document.cookie = cookieName + '=' + escape(cookieValue) + '; path=/; secure;';
  }
  // non static
  updatePath(){
    var pathName = window.location.pathname;
    if(pathName !== ChatUtils.readCookie(ChatUtils.COOKIE_CONSTANTS.PATH_1)) {
      ChatUtils.shiftPathCookies();
      ChatUtils.writeCookie(ChatUtils.COOKIE_CONSTANTS.PATH_1, pathName);
    }
  }

  /////////////////////////
  /*  CHAT MANIPULATION  */
  /////////////////////////

  //////////////////////////////////////////////////////////////////////////////////////////////////////
  // OBSERVATION PART
  // main button observer
  runsNewChat(){
    var ctx = this;
    // Dynamic init of components to be loaded
    var $this = this;
    // observer listener
    function listener(records) {
      var nodes = [];
      records.forEach(function (record) {
        var list = record.addedNodes;
        var i = list.length - 1;
        for ( ; i > -1; i-- ) {
          // if i find a new component
          if ( typeof list[i] == 'object' && list[i].nodeType == '1') {
            // if i find the chat button
            if (list[i].getAttribute('class') !== null  ) {
              var classes = list[i].getAttribute('class').split(' ');
              if (list[i].getAttribute('class') == 'embeddedServiceHelpButton'  || classes.includes('embeddedServiceHelpButton') ) {
                // chat button appears + add class
                list[i].classList.add('livechat-button');
                // insert chat icon
                var btn = list[i].querySelector('.embeddedServiceIcon');
                if ( btn != null) {
                  btn.innerHTML =  '<div class="icon-live-chat"></div>';
                }
                // bind button start prechat
                ctx.startButton();
                // Personal Stylist button
                ctx.bindPSChat();
              }
            }
            if (list[i].getAttribute('class') !== null  ) {
              var classes = list[i].getAttribute('class').split(' ');
              // if the prechat opens i launch another observer
              if (classes.includes('modalContainer') && classes.includes('embeddedServiceSidebar') ) {
                // when chat window is opened
                ctx.prechatObserver(list[i]);
              }
              if (classes.includes('embeddedServiceLiveAgentStateWaiting')) {
                ctx.deleteChat(list[i]);
              }
            }
            if (list[i].getAttribute('class') == 'endChatContainer' ) {
              // chat ending
              ctx.chatEnding();
            }
          }
        }
      });
    }
    // define observer
    var observer = new MutationObserver(listener);
    // nodes to observe
    var sizeNode = document.querySelector('body');
    if ( typeof sizeNode != 'undefined' && sizeNode != null ) {
      // loop to observe each node
      observer.observe(sizeNode, { childList: true, subtree: true });
    }
  }

  // prechat observer
  prechatObserver(div) {
    // Dynamic init of components to be loaded
    var ctx = this;
    // observer listener
    function listener(records) {
      var nodes = [];
      records.forEach(function (record) {
        var list = record.addedNodes;
        var i = list.length - 1;
        for ( ; i > -1; i-- ) {
          // if i find a new component
          if ( typeof list[i] == 'object' && list[i].nodeType == '1') {
            // let's get the div
            if (list[i].getAttribute('class') !== null  ) {
              // if there is a certain class
              var classes = list[i].getAttribute('class').split(' ');
              if (classes.includes('prechatUI')) {
                ctx.manipulatePrechat(div);
              }
              // error on sending chat
              if (classes.includes('has-error')) {
                ctx.errorPrechat(div,list[i]);
                // add class on dockablecontainer
                var container = document.querySelector(ctx.SELECTORS.chatDock);
                container.classList.add('prechat');
              }
              // remove the class at the loader
              if (classes.includes('loadingBallContainer')) {
                // remove class on dockablecontainer
                var container = document.querySelector(ctx.SELECTORS.chatDock);
                container.classList.remove('prechat');
              }
            }
          }
        }
      });
    }
    // define observer
    var observer = new MutationObserver(listener);
    // nodes to observe
    var sizeNode = document.querySelector('.embeddedServiceSidebar');
    if ( typeof sizeNode != 'undefined' && sizeNode != null ) {
      // loop to observe each node
      observer.observe(sizeNode, { childList: true, subtree: true });
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////
  //  MANIPULATION PART

  // maniupulate the prechat html
  manipulatePrechat(div) {
    // console.log('manipulate prechat');
    // remove loading class on button
    var btn = document.querySelector(this.SELECTORS.chatButton);
    btn.classList.remove('loading');

    // add class on dockablecontainer
    var container = document.querySelector(this.SELECTORS.chatDock);
    container.classList.add('prechat');

    // fieldlist inside prechat
    var fieldList = div.querySelector('.fieldList');

    // chat label pre-fields
    if (this.chatLabelStart != '') {
      var chatLabelStartDiv = document.createElement('div');
      chatLabelStartDiv.classList.add('fieldsTitle');
      chatLabelStartDiv.innerHTML = this.chatLabelStart;
      // insert as first child
      fieldList.insertBefore(chatLabelStartDiv, fieldList.firstChild);
    }

    // label override
    this.overrideLabels(div);

    // hide fields
    this.hidePrechatFields(div);

    // min-lenght fields
    var firstName = div.querySelector('#FirstName');
    var lastName = div.querySelector('#LastName');
    firstName.setAttribute('minlength',3);
    lastName.setAttribute('minlength',3);

    // subject select
    this.createSubjectSelect(div);

    // privacy checbox
    this.createPrivacyCheckbox(div);

    // start button
    this.createStartButton(div);

    // callbacks called with events
    var evt = document.createEvent("Events");
    evt.initEvent("prechatOpened", true, true);
    document.dispatchEvent(evt);

    // label bind!!! optonal
    if (typeof this.options.labelBindHiding !== 'undefined' && this.options.labelBindHiding === 'true') {
      this.labelBindHiding(div);
    }

  }

  overrideLabels(div) {
    // label override!!!
    // chatLabelName
    if (this.chatLabelName != '') {
      if (div.querySelector('#FirstName') != null) {
        div.querySelector('#FirstName').closest('div.uiInput').querySelector('label').innerHTML  = this.chatLabelName;
      }
    }
    // chatLabelLastname
    if (this.chatLabelLastname != '') {
      if (div.querySelector('#LastName') != null) {
        div.querySelector('#LastName').closest('div.uiInput').querySelector('label').innerHTML  = this.chatLabelLastname;
      }
    }
    // chatLabelEmail
    if (this.chatLabelEmail != '') {
      if (div.querySelector('#Email') != null) {
        div.querySelector('#Email').closest('div.uiInput').querySelector('label').innerHTML  = this.chatLabelEmail;
      }
    }
  }

  // hide fields in prechat
  hidePrechatFields(div) {
    // hiding fields = main selector : closest selector
    var hidingFields =  {
     '#LiveChat_Path1__c': 'div.inputText',
     '#LiveChat_Path2__c': 'div.inputText',
     '#LiveChat_Path3__c': 'div.inputText',
     '#LiveChat_Path4__c': 'div.inputText',
     '#LiveChat_Path5__c': 'div.inputText',
     '#LiveChat_Brand__c': 'div.inputSelect',
     '#website_iso_country_code__c': 'div.inputText',
     '#Primary_Language__c': 'div.inputSelect',
     '#LiveChat_Subject__c': 'div.inputText',
    }
    // loop the fields
    for(var key in hidingFields) {
      // check and hide
      if (div.querySelector(key) != null) {
        div.querySelector(key).closest(hidingFields[key]).classList.add('--hidden');
      }
    }
  }

  // create subject select
  createSubjectSelect(div) {
    // check preselected subject
    var preselSubject = document.querySelector(this.SELECTORS.chatPreselectedSubject).value;
    if (preselSubject != '') {
      div.querySelector('#LiveChat_Subject__c').value = preselSubject;
      var evt = document.createEvent("Events");
      evt.initEvent("change", true, true);
      div.querySelector('#LiveChat_Subject__c').dispatchEvent(evt);
      return;
    }
    // fields
    var fieldList = div.querySelector('.fieldList');
    // subject select
    var subjectDiv = document.createElement('div');
    subjectDiv.classList.add('inputSelect','embeddedServiceSidebarFormField','subjectSelect','form-group');
    // div select
    var selectDiv = document.createElement('div');
    selectDiv.classList.add('uiInput','uiInput--default','uiInputSelect','uiInput--select');
    // label
    var selectDivLabel = document.createElement('label');
    selectDivLabel.classList.add('uiLabel','uiLabel-left','form-element__label');
    selectDivLabel.innerHTML = this.chatLabelSubject;
    // append to select div
    selectDiv.append(selectDivLabel);
    // create select and options
    var subjectSelect = document.createElement('select');
    subjectSelect.setAttribute('name','subjectSelect') ;
    subjectSelect.setAttribute('id','subjectSelect') ;
    subjectSelect.setAttribute('placeholder',this.chatLabelSubject) ;
    // stock classes
    if (typeof this.options.subjectClassesDefault === 'undefined' || this.options.subjectClassesDefault !== 'false') {
      subjectSelect.classList.add('slds-style-select','select','js-subject','mc-custom');
    }
    if (typeof this.options.subjectIcon === 'undefined' || this.options.subjectIcon !== 'false') {
      if (typeof this.options.subjectIconClass !== 'undefined') {
        var selectIcon = document.createElement('div');
        // check if is array and add classes
        var classArr = this.options.subjectIconClass;
        if (Array.isArray(classArr)) {
          // loop the classes to add them
          classArr.forEach((cls, i) => {
            selectIcon.classList.add(cls);
          });
        }
        selectDiv.append(selectIcon);
      }
    }
    // options classes
    if (typeof this.options.subjectClasses !== 'undefined') {
      // check if is array and add classes
      var classArr = this.options.subjectClasses;
      if (Array.isArray(classArr)) {
        // loop the classes to add them
        classArr.forEach((cls, i) => {
          subjectSelect.classList.add(cls);
        });
      }
    }
    // check list on options
    if (typeof this.options.subjects !== 'undefined') {
      for (const key in this.options.subjects) {
        if (this.options.subjects.hasOwnProperty(key)) {
          // set value
          subjectSelect.options[subjectSelect.options.length] = new Option(this[key], this.options.subjects[key]);
        }
      }
    }
    // append to select div
    selectDiv.append(subjectSelect);
    // append to subject div
    subjectDiv.append(selectDiv);
    // append to fields
    fieldList.append(subjectDiv);
    // first val setting
    if (subjectSelect.value !== '') {
      div.querySelector('#LiveChat_Subject__c').value = subjectSelect.value;
      var evt = document.createEvent("Events");
      evt.initEvent("change", true, true);
      div.querySelector('#LiveChat_Subject__c').dispatchEvent(evt);
    }
    // event!
    subjectSelect.addEventListener('change',e => {
      // this works
      div.querySelector('#LiveChat_Subject__c').value = subjectSelect.value;
      var evt = document.createEvent("Events");
      evt.initEvent("change", true, true);
      div.querySelector('#LiveChat_Subject__c').dispatchEvent(evt);
    });
  }

  createPrivacyCheckbox(div) {
    // fields
    var fieldList = div.querySelector('.fieldList');
    // checkbox
    var checkboxMain = document.createElement('label');
    checkboxMain.classList.add('inputText', 'embeddedServiceSidebarFormField', 'privacyInput', 'custom-checkbox');
    var checkbox = document.createElement('input');
    checkbox.setAttribute('type', 'checkbox');
    checkbox.setAttribute('id', 'privacyInput');
    var label = document.createElement('span');
    label.innerHTML = this.chatLabelPrivacy;
    var checkmark = document.createElement('span');
    checkmark.classList.add('custom-checkbox__checkmark');
    // append to checkbox div
    checkboxMain.append(label);
    checkboxMain.append(checkbox);
    checkboxMain.append(checkmark);
    // append to fields
    fieldList.append(checkboxMain);
  }

  //
  createStartButton(div) {
    // fake button
    var fakeSubmit = document.createElement('a');
    fakeSubmit.setAttribute('href','javascript:void(0)');
    fakeSubmit.classList.add('fakeSubmit','disabled');
    // stock class
    if (typeof this.options.ctaClassesDefault === 'undefined' || this.options.ctaClassesDefault !== 'false') {
      fakeSubmit.classList.add('embeddedServiceSidebarButton','uiButton--default','uiButton');
    }
    // options class
    if (typeof this.options.ctaClasses !== 'undefined') {
      // check if is array and add classes
      var classArr = this.options.ctaClasses;
      if (Array.isArray(classArr)) {
        // loop the classes to add them
        classArr.forEach((cls, i) => {
          fakeSubmit.classList.add(cls);
        });
      }
    }
    // button inner html
    fakeSubmit.innerHTML = this.chatLabelCTA;
    // append button
    var buttonWrapper = div.querySelector('.buttonWrapper');
    buttonWrapper.querySelector('button').classList.add('--hidden');
    buttonWrapper.append(fakeSubmit);
    // bind action
    this.bindStartChat(div);
    // go PS chat if banner is not null, if is disappeared but is not launched or not launch by click
    if (this.personalStylistBanner != null &&
        this.personalStylistBanner.classList.contains('disappeared') &&
        !this.personalStylistBanner.classList.contains('launched') &&
        !this.personalStylistBanner.classList.contains('launch_on_click')
      ) {
      // control class
      this.personalStylistBanner.classList.add('launched');
      // launch chat
       document.querySelector('.startButton').click();
    }
  }

  // hide label on click
  labelBindHiding(div) {
    // fields
    var fieldList = div.querySelector('.fieldList');
    // label bind!!!
    var inputs = fieldList.querySelectorAll('input');
    if(inputs != null) {
      inputs.forEach(input => {
        var label = input.closest('.embeddedServiceSidebarFormField').querySelector('label');
        input.addEventListener('keyup',e => {
          if (e.target.value !== '') {
            label.classList.add('--hidden');
          } else {
            label.classList.remove('--hidden');
          }
        });
      });
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////
  // FUNCTIONALITY PART

  // start chat button
  startButton() {
    var btn = document.querySelector(this.SELECTORS.chatButton);
    btn.addEventListener('click',e => {
      btn.classList.add('loading');
      // reset width small trick
      var setIntervalBtn = setInterval(function(){
        if (btn.closest('.helpButton').style.width != '') {
          btn.closest('.helpButton').style.width = 'auto';
          clearInterval(setIntervalBtn);
        }
      }, 10);

      var eventName = 'startChat';
      var evt = new Event(eventName, {
        bubbles: true,
        cancelable: true
      });
      document.dispatchEvent(evt);
    });
    // extra chat link on menus
    if (this.startChatLink != null) {
      this.startChatLink.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        if (btn != null) {
          btn.click();
        }
      });
    }
  }
  // bind the fake button to the start chat button
  bindStartChat(div) {
    // bind click btn
    var fakeBtn = div.querySelector('.fakeSubmit');
    var btn = div.querySelector('.buttonWrapper button');
    var privacyInput = div.querySelector('#privacyInput');
    fakeBtn.addEventListener('click', e => {
      // check
      if (privacyInput.checked && this.checkForm(div)) {
        btn.click();
        this.TrackingComponent.actions.startChat();
      } else {
        // fallback
        if (!privacyInput.checked) {
          privacyInput.closest('.privacyInput').style.color = 'red';
        }
      }
    });
    // bind enable btn
    privacyInput.addEventListener('change', e => {
      if (e.target.checked) {
        fakeBtn.classList.remove('disabled');
      } else {
        fakeBtn.classList.add('disabled');
      }
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////
  // CHECKS PART
  // error prechat
  errorPrechat(div,el){
    // i only care about fake fields
    // SUBJECT
    var subjectSelect = el.previousElementSibling.querySelector('input#LiveChat_Subject__c');
    if (subjectSelect != null) {
      var subjectDiv = div.querySelector('.subjectSelect');
      if (subjectDiv != null) {
        subjectDiv.append(el);
        subjectDiv.querySelector('.uiInputSelect').classList.add('has-error');
      }
    }
  }

  // checks form
  checkForm(div){
    // init
    var pass = [];
    // fields
    var fields = {
      '#FirstName': {
        'type' : 'length',
        'value' : 3
      },
      '#LastName': {
        'type' : 'length',
        'value' : 3
      }
    }
    for (const fieldName in fields){
      if(fields.hasOwnProperty(fieldName)){
        // get input
        var input = div.querySelector(fieldName);
        // types
        // length
        if (fields[fieldName].type == 'length') {
          if (input.value.length == 0 || input.value.length >= fields[fieldName].value ) {
            // pass
            pass.push('true');
            // clean error if not empty
            if (input.value.length != 0) {
              this.cleanFieldError(input);
            }
          } else {
            // no pass
            pass.push('false');
            // set
            this.setFieldError(input,'length');
          }
        }
      }
    }
    // salesforce standard fields
    var emailInput = div.querySelector('input#Email');
    var subjectInput = div.querySelector('input#LiveChat_Subject__c');
    // reset errorrr if subject is not empty !!!! (because the subject field is fake)
    if (subjectInput.value != '' && div.querySelector('.subjectSelect .uiInputSelect') != null ) {
      div.querySelector('.subjectSelect .uiInputSelect').classList.remove('has-error');
    }
    // if one of the 2 field is empty i want to trigger the salesforce validation
    if (emailInput.value == '' || subjectInput.value == '') {
      return true;
    }
    // return true if i dont find fals in pass array
    return !pass.includes('false');
  }

  // set the error field
  setFieldError(div,type) {
    if (div != null) {
      // set error classes
      div.classList.add('has-error');
      div.closest('.uiInput').classList.add('has-error');
      var label = '';
      // adding error ul
      var inputBox = div.closest('.embeddedServiceSidebarFormField');
      // check
      if (inputBox.querySelector('ul.uiInputDefaultError')) return;
      // label
      if (type == 'length') {
        label = this.chatLabelLengthError;
      }
      // create ul
      var errorUl = document.createElement('ul');
      errorUl.classList.add('uiInput','uiInputDefaultError','has-error','uiInput--default','uiInput--input');
      var errorLi = document.createElement('li');
      errorLi.setAttribute('class','form-element__help');
      errorLi.innerHTML = label;
      errorUl.appendChild(errorLi);
      // append error
      inputBox.append(errorUl);
    }
  }

  // clean the error from field
  cleanFieldError(div) {
    // remove class
    div.classList.remove('has-error');
    // box
    var inputBox = div.closest('.embeddedServiceSidebarFormField');
    // find error box
    var errorBox = inputBox.querySelector('ul.uiInputDefaultError');
    if (errorBox != null) {
      errorBox.remove();
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////
  // ENDING PART
  // chat ending
  chatEnding() {
    // vars
    var endChatContainer = document.querySelector(this.SELECTORS.endChatContainer);
    var endChatMessage = document.querySelector(this.SELECTORS.endChatMessage);
    // if i find the wrapper i append the endchat
    if (endChatContainer != null) {
      var endChatContent = document.querySelector(this.SELECTORS.endChatContent);
      var endChatText = endChatContent.cloneNode(true);
      endChatText.classList.remove('--hidden');
      // insert as first child
      endChatContainer.insertBefore(endChatText, endChatContainer.firstChild);
      // add class
      endChatMessage.classList.add('chatEnded');
    }
    // save transcription
    var downloadBtn = document.querySelector(this.SELECTORS.endChatContainer+' .container-feedback .btn-download a');
    if (downloadBtn != null) {
      downloadBtn.addEventListener('click', () => {
        var saveBtn = document.querySelector(this.SELECTORS.endChatContainer+' .saveTranscriptButton');
        if (saveBtn != null) {
          saveBtn.click();
        }
      });
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////
  // DELETE CHAT BEFORE START

  deleteChat(deleteChatBtn) {
    deleteChatBtn.addEventListener('click', e => {
      this.TrackingComponent.actions.deleteChat();
    });
  }

  /////////////////////////
  /*  PERSONAL STYLIST   */
  /////////////////////////
  // bind PS chat
  bindPSChat() {
    // PS part
    var ctx = this;
    if (this.personalStylistSnapConfig != null) {
      // PS Chat binded
      // check cookie and launch PS
      if(Cookies.get(this.hideCookieKey) == 'undefined' || !Cookies.get(this.hideCookieKey)){
        // launch ps chat bind
        this.setupPersonalStylistDelayedPopup(parseInt(this.personalStylistPopUpTriggerTime, 10));
      }
      // set cookie  on close to avoid show button
      var closeBtn = this.personalStylistCloseBtn;
      if ( closeBtn != null ) {
        closeBtn.addEventListener('click', () => {
          Cookies.set(ctx.hideCookieKey, 'true', {
            path: '/'
          });
          // hide button
          ctx.personalStylistBanner.classList.add('disappeared','--hidden','launched');
        });
      }
    }
  }

  // display PS button
  setupPersonalStylistDelayedPopup(triggerIn){
    var ctx = this;
    // click start chat button
    var chatButton = document.querySelector(this.SELECTORS.chatButton);
    // if there is the start chat button , i bind the start chat
    if (this.personalStylistStartChat != null) {
      this.personalStylistStartChat.addEventListener('click',e => {
        e.stopPropagation();
        // init chat
        // if is logged in
        if (this.customerLoggedIn === 'true') {
           ctx.initializeChat(true);
        } else {
          // if not i set the preselected subject
          document.querySelector(this.SELECTORS.chatPreselectedSubject).value = this.options.subjects.chatLabelSubjectOptionPS;
          // hide button
          ctx.personalStylistBanner.classList.add('launch_on_click');
        }
        // click start chat button
        chatButton.click();
        // remove PS banner
        // hide button
        ctx.personalStylistBanner.classList.add('disappeared','--hidden');
        // put cookie
        Cookies.set(ctx.hideCookieKey, 'true', {
          path: '/'
        });
      });
    }
    // if there is the banner i want to show it
    if (this.personalStylistBanner != null) {
      // button appears if there are buttons to start chat or whatsapp
      setTimeout(()=> {
        if((ctx.personalStylistStartWhatsApp != null || ctx.personalStylistStartChat != null ) && chatButton.classList.contains('helpButtonEnabled') ) {
          ctx.personalStylistBanner.classList.remove('--hidden');
        }
      }, triggerIn);
      // hide push on disable button
      document.addEventListener('chatButtonDisabled', () => {
        ctx.personalStylistBanner.classList.add('--hidden');
      });
      // show push on enable button
      document.addEventListener('chatButtonEnabled', () => {
        setTimeout(()=> {
          if((ctx.personalStylistStartWhatsApp != null || ctx.personalStylistStartChat != null ) && chatButton.classList.contains('helpButtonEnabled') && !this.personalStylistBanner.classList.contains('disappeared') ) {
            ctx.personalStylistBanner.classList.remove('--hidden');
          }
        }, triggerIn);
      });
      // prechatOpened
      document.addEventListener('prechatOpened', () => {
        // if the preselected subject is filled, i reset it so the next time is not preselected
        const element = document.querySelector(ctx.SELECTORS.chatPreselectedSubject);
        if (element) {
          element.value = '';
        }
      });

    }
  }

  addToObject(obj, key, value, index) {
    // Create a temp object and index variable
    var temp = {};
    var i = 0;
    // Loop through the original object
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        // If the indexes match, add the new item
        if (i === index && key && value) {
          temp[key] = value;
        }
        // Add the current item in the loop to the temp obj
        temp[prop] = obj[prop];
        // Increase the count
        i++;
      }
    }
    // If no index, add to the end
    if (!index && key && value) {
      temp[key] = value;
    }
    return temp;
  }

}

export default new ChatUtils();
